<template>
    <div class="question_panel">
        <div class="question_panel_percent">
            <div class="percent_info">
                <div class="percent_info_left">
                    <div>得分率</div>
                    <div class="info_num">{{questionInfo.scoreRate | percent}}<span>%</span></div>
                </div>
                <div v-show="optionNumList.length" ref="eCharts" class="percent_info_chart" style="width: 60px;height: 60px"></div>
            </div>
            <div class="percent_info">
                <div class="percent_info_option">
                    <span class="info_option_icon icon-suc"></span>
                    <span class="info_option_text">答对</span>
                </div>
                <div class="percent_info_option">
                    <span class="info_option_icon icon-half"></span>
                    <span class="info_option_text">半对</span>
                </div>
                <div class="percent_info_option">
                    <span class="info_option_icon icon-err"></span>
                    <span class="info_option_text">答错</span>
                </div>
                <div class="percent_info_option">
                    <span class="info_option_icon"></span>
                    <span class="info_option_text">未答</span>
                </div>
            </div>
        </div>
        <div v-show="optionNumList.length" ref="optionContent" class="question_panel_answer">
            <div v-for="(item,index) in optionNumList" :key="index" class="answer_option">
                <div>选项{{item.name}}</div>
                <div class="answer_option_num">{{item.num}}<span class="answer_option_unit">人</span></div>
            </div>
        </div>
        <div ref="studentContent" class="question_panel_student" :style="{height: studentHeight}">
            <div class="question_panel_student_title">作答情况</div>
            <div v-for="item in panelStudent" :key="item.id" class="student_option" :class="{'err': item.check === 3, 'suc': item.check === 1, 'half': item.check === 2}">
                <span class="student_code">{{item.showCode}}</span>
                <span class="student_name">{{item.name}} <span v-if="questionInfo.typeName === '选择题'">{{item.answer}}</span></span>
            </div>
        </div>
        <div @click="studentDialogVisible = true" class="question_panel_detail">
            <img src="../../../assets/image/ttWork/record/detail-icon.png" alt="">
            <span>详细名单</span>
        </div>
        <el-dialog :visible.sync="studentDialogVisible" :modal-append-to-body="true" :append-to-body="true" custom-class="student-answer" top="0" :show-close="false">
            <div class="student-answer_title">作答情况</div>
            <div class="student-answer_container">
                <div class="student-answer_content">
                    <div v-for="(student, index) in answerDetail" @click="showAnswerDialog(student)" :key="index" class="student_item" :class="{'err': student.check === 3, 'suc': student.check === 1, 'half': student.check === 2}">
                        <span class="code" style="cursor: default">{{student.showCode}}</span>
                        <div class="student_item_right">
                            <div style="cursor: default">{{student.name}}&nbsp;</div>
                            <div v-show="questionInfo.typeName === '选择题'" style="cursor: default">{{student.answer}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="student-answer_close">
                <button class="answer_close_btn" @click="studentDialogVisible = false">关 闭</button>
            </div>
        </el-dialog>
        <el-dialog :visible.sync="answerDialogVisible" :modal-append-to-body="true" :append-to-body="true" custom-class="answer-dialog" top="0" :show-close="false">
            <div class="answer_title">{{activeStudent.name}}</div>
            <div class="answer_content"></div>
            <div class="answer_close">
                <button class="close_btn" @click="answerDialogVisible = false">关 闭</button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: "QuestionPanel",
        data () {
            return {
                studentDialogVisible: false,
                answerDialogVisible: false,
                eCharts: null, // 饼图
                studentHeight: '', // 作答情况高度
                optionNumList: [], // 选项人数
                answerDetail: [], // 回答详情
                panelStudent: [], // 显示详情
                activeStudent: {}, // 当前选择的学生
                noAnswerNum: 0, // 未答人数
                answerSucNum: 0, // 正确人数
                answerErrNum: 0, // 答错人数
                answerHalfNum: 0 // 半对人数
            }
        },
        props: {
            questionInfo: {
                type: Object,
                default: () => {
                    return {}
                }
            }
        },
        watch: {
            questionInfo: {
                deep: true,
                handler (newV) {
                    this.initData(newV);
                }
            },
            studentHeight () {
                this.$nextTick(() => {
                    this.panelStudent = this.answerDetail.slice(0, Math.floor((this.$refs.studentContent.offsetHeight - 55) / 37));
                })
            }
        },
        filters: {
            percent (value) {
                return value || value === 0 ? Math.floor(Number(value) * 100) : '--'
            }
        },
        mounted () {
        },
        methods: {
            initData (data) {
                this.optionNumList = [];
                if (Object.keys(data.answerCounting).length) {
                    for (let item in data.answerCounting) {
                        this.optionNumList.push({
                            name: item,
                            num: data.answerCounting[item]
                        })
                    }
                }
                if (Object.keys(data.checkCounting).length) {
                    this.noAnswerNum = data.checkCounting[0] || 0;
                    this.answerSucNum = data.checkCounting[1] || 0;
                    this.answerErrNum = data.checkCounting[3] || 0;
                    this.answerHalfNum = data.checkCounting[2] || 0;
                } else {
                    this.noAnswerNum = 0;
                    this.answerSucNum = 0;
                    this.answerErrNum = 0;
                }
                if (this.optionNumList.length) {
                    this.$nextTick(() => {
                        let height = this.$refs.optionContent.offsetHeight;
                        this.studentHeight = `calc(100% - ${132 + height}px)`
                        this.$nextTick(() =>{
                            this.drawECharts();
                        })
                    })
                } else {
                    this.studentHeight = 'calc(100% - 130px)'
                }
                this.answerDetail = data.answerDetail.map(item => {
                    item.showCode = item.code && item.code.slice(item.code.length - 2);
                    return item
                });
            },
            showAnswerDialog (student) {
                this.activeStudent = student;
                // this.answerDialogVisible = true;
            },
            drawECharts () {
                if (this.eCharts) {
                    this.eCharts.dispose();
                }
                this.eCharts = this.$echarts.init(this.$refs.eCharts);
                this.eCharts.setOption({
                    backgroundColor: "#ffffff",
                    title: {
                        show: false
                    },
                    tooltip: {
                        trigger: 'item',
                        show: false,
                        formatter: "{a} <br/>{b} : {c} ({d}%)"
                    },
                    calculable: true,
                    series: [
                        {
                            name: '面积模式',
                            type: 'pie',
                            radius: [20, 30],
                            center: ['50%', '50%'],
                            itemStyle: {
                                normal: {
                                    label: {
                                        show: false
                                    },
                                    labelLine: {
                                        show: false
                                    }
                                }
                            },
                            hoverAnimation: false,
                            data: [
                                {
                                    value: this.answerSucNum,
                                    name: 'rose2',
                                    itemStyle: {
                                        color: new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                                            offset: 0,
                                            color: '#62A9F1'
                                        }, {
                                            offset: 1,
                                            color: '#6BC4FB'
                                        }])
                                    }
                                },
                                {
                                    value: this.answerHalfNum,
                                    name: 'rose3',
                                    itemStyle: {
                                        color: new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                                            offset: 0,
                                            color: 'rgba(222,222,222,0)'
                                        }, {
                                            offset: 1,
                                            color: 'rgba(222,222,222,0)'
                                        }])
                                    }
                                },
                                {
                                    value: this.answerErrNum,
                                    name: 'rose1',
                                    itemStyle: {
                                        color: new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                                            offset: 0,
                                            color: 'rgba(222,222,222,0)'
                                        }, {
                                            offset: 1,
                                            color: 'rgba(222,222,222,0)'
                                        }])
                                    }
                                },{
                                    value: this.noAnswerNum,
                                    name: '1',
                                    itemStyle: {
                                        color: new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                                            offset: 0,
                                            color: 'rgba(222,222,222,0)'
                                        }, {
                                            offset: 1,
                                            color: 'rgba(222,222,222,0)'
                                        }])
                                    },
                                }
                            ]
                        },
                        {
                            name: '面积模式',
                            type: 'pie',
                            radius: [21, 29],
                            center: ['50%', '50%'],
                            itemStyle: {
                                normal: {
                                    label: {
                                        show: false
                                    },
                                    labelLine: {
                                        show: false
                                    }
                                }
                            },
                            hoverAnimation: false,
                            data: [
                                {
                                    value: this.answerSucNum,
                                    name: 'rose2',
                                    itemStyle: {
                                        color: new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                                            offset: 0,
                                            color: 'rgba(222,222,222,0)'
                                        }, {
                                            offset: 1,
                                            color: 'rgba(222,222,222,0)'
                                        }])
                                    }
                                },
                                {
                                    value: this.answerHalfNum,
                                    name: 'rose3',
                                    itemStyle: {
                                        color: new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                                            offset: 0,
                                            color: '#FEB15B'
                                        }, {
                                            offset: 1,
                                            color: '#FEB15B'
                                        }])
                                    }
                                },
                                {
                                    value: this.answerErrNum,
                                    name: 'rose1',
                                    itemStyle: {
                                        color: new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                                            offset: 0,
                                            color: 'rgba(222,222,222,0)'
                                        }, {
                                            offset: 1,
                                            color: 'rgba(222,222,222,0)'
                                        }])
                                    }
                                },{
                                    value: this.noAnswerNum,
                                    name: '1',
                                    itemStyle: {
                                        color: new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                                            offset: 0,
                                            color: 'rgba(222,222,222,0)'
                                        }, {
                                            offset: 1,
                                            color: 'rgba(222,222,222,0)'
                                        }])
                                    },
                                }
                            ]
                        },
                        {
                            name: '面积模式',
                            type: 'pie',
                            radius: [22, 28],
                            center: ['50%', '50%'],
                            itemStyle: {
                                normal: {
                                    label: {
                                        show: false
                                    },
                                    labelLine: {
                                        show: false
                                    }
                                }
                            },
                            hoverAnimation: false,
                            data: [
                                {
                                    value: this.answerSucNum,
                                    name: 'rose2',
                                    itemStyle: {
                                        color: new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                                            offset: 0,
                                            color: 'rgba(222,222,222,0)'
                                        }, {
                                            offset: 1,
                                            color: 'rgba(222,222,222,0)'
                                        }])
                                    }
                                },
                                {
                                    value: this.answerHalfNum,
                                    name: 'rose3',
                                    itemStyle: {
                                        color: new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                                            offset: 0,
                                            color: 'rgba(222,222,222,0)'
                                        }, {
                                            offset: 1,
                                            color: 'rgba(222,222,222,0)'
                                        }])
                                    }
                                },
                                {
                                    value: this.answerErrNum,
                                    name: 'rose1',
                                    itemStyle: {
                                        color: new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                                            offset: 0,
                                            color: '#F7733D'
                                        }, {
                                            offset: 1,
                                            color: '#FE986F'
                                        }])
                                    }
                                },{
                                    value: this.noAnswerNum,
                                    name: '1',
                                    itemStyle: {
                                        color: new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                                            offset: 0,
                                            color: 'rgba(222,222,222,0)'
                                        }, {
                                            offset: 1,
                                            color: 'rgba(222,222,222,0)'
                                        }])
                                    },
                                }
                            ]
                        },
                        {
                            name: '面积模式',
                            type: 'pie',
                            radius: [23, 27],
                            center: ['50%', '50%'],
                            itemStyle: {
                                normal: {
                                    label: {
                                        show: false
                                    },
                                    labelLine: {
                                        show: false
                                    }
                                }
                            },
                            hoverAnimation: false,
                            data: [
                                {
                                    value: this.answerSucNum,
                                    name: 'rose2',
                                    itemStyle: {
                                        color: new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                                            offset: 0,
                                            color: 'rgba(222,222,222,0)'
                                        }, {
                                            offset: 1,
                                            color: 'rgba(222,222,222,0)'
                                        }])
                                    }
                                },
                                {
                                    value: this.answerHalfNum,
                                    name: 'rose3',
                                    itemStyle: {
                                        color: new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                                            offset: 0,
                                            color: 'rgba(222,222,222,0)'
                                        }, {
                                            offset: 1,
                                            color: 'rgba(222,222,222,0)'
                                        }])
                                    }
                                },
                                {
                                    value: this.answerErrNum,
                                    name: 'rose1',
                                    itemStyle: {
                                        color: new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                                            offset: 0,
                                            color: 'rgba(222,222,222,0)'
                                        }, {
                                            offset: 1,
                                            color: 'rgba(222,222,222,0)'
                                        }])
                                    }
                                },{
                                    value: this.noAnswerNum,
                                    name: '1',
                                    itemStyle: {
                                        color: new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                                            offset: 0,
                                            color: '#EBEBEB'
                                        }, {
                                            offset: 1,
                                            color: '#EBEBEB'
                                        }])
                                    },
                                }
                            ]
                        },
                    ]
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    .question_panel{
        padding: 18px 24px;
        position: relative;
        height: 100%;
        box-sizing: border-box;
        .question_panel_percent{
            border-bottom: 1px dashed #D1D1D1;
            padding-bottom: 12px;
            .percent_info{
                display: flex;
                align-items: center;
                justify-content: space-between;
                flex-wrap: wrap;
                .percent_info_left{
                    font-size: 16px;
                    color: #333333;
                    line-height: 1;
                    text-align: left;
                    .info_num{
                        font-size: 30px;
                        color: #2996F3;
                        font-weight: 600;
                        margin-top: 5px;
                        span{
                            font-size: 20px;
                        }
                    }
                }
                .percent_info_chart{}
                .percent_info_option{
                    margin-top: 5px;
                    margin-left: -7px;
                    width: 60px;
                    .info_option_icon{
                        display: inline-block;
                        margin-right: 2px;
                        width: 6px;
                        height: 6px;
                        border-radius: 50%;
                        /*vertical-align: middle;*/
                        border:2px solid rgba(212,212,212,1);
                        background: rgba(212,212,212,1);
                    }
                    .icon-suc{
                        border-color: #2996F3;
                        background: #2996F3;
                    }
                    .icon-err{
                        border-color: #F7733D;
                        background: #F7733D;
                    }
                    .icon-half{
                        border-color: #FEB15B;
                        background: #FEB15B;
                    }
                    .info_option_text{
                        display: inline-block;
                        /*vertical-align: middle;*/
                        color: #333333;
                        font-size: 14px;
                    }
                }
            }
        }
        .question_panel_answer{
            display: flex;
            align-items: center;
            justify-content: flex-start;
            flex-wrap: wrap;
            padding: 18px 0;
            border-bottom: 1px dashed #D1D1D1;
            .answer_option{
                font-size: 14px;
                color: #000000;
                width: 75px;
                padding-right: 20px;
                text-align: left;
                box-sizing: border-box;
                white-space: nowrap;
                .answer_option_num{
                    color: #41A1F4;
                    font-size: 30px;
                    .answer_option_unit{
                        font-size: 14px;
                    }
                }
            }
            .answer_option:nth-child(2n){
                padding-right: 0;
                width: 45px;
            }
        }
        .question_panel_student{
            padding: 11px 0 0 0;
            text-align: left;
            box-sizing: border-box;
            .question_panel_student_title{
                font-size: 16px;
                color: #333333;
                margin-bottom: 11px;
            }
            .student_option{
                height:29px;
                background:rgba(212,212,212,1);
                box-shadow:0 2px 4px 0 rgba(212,212,212,.5);
                border-radius:6px;
                margin-top: 8px;
                padding-left: 13px;
                display: flex;
                align-items: center;
                color: white;
                line-height: 1;
                justify-content: flex-start;
                .student_code{
                    font-size: 14px;
                    width: 26px;
                }
                .student-name{
                    font-size: 14px;
                }
            }
            .err{
                background:#f7733d;
                box-shadow:0 2px 4px 0 rgba(255,195,189,1);
            }
            .suc{
                background:rgba(41,160,254,1);
                box-shadow:0 2px 4px 0 rgba(157,212,255,1);
            }
            .half{
                background:#feb15b;
                box-shadow:0px 2px 4px 0px rgba(255,223,187,1);
            }
        }
        .question_panel_detail{
            display: inline-flex;
            align-items: center;
            justify-content: center;
            font-size: 16px;
            cursor: pointer;
            color: #2996F3;
            margin-top: -10px;
            img{
                width: 20px;
                margin-right: 8px;
            }
        }
        /deep/ .student-answer{
            width:1148px;
            height: 536px;
            text-align: left;
            background:rgba(255,255,255,1);
            box-shadow:0 0 20px 0 rgba(0,0,0,0.15);
            border-radius:17px;
            position: relative;
            top: calc(50% - 370px);
            margin: 0 auto;
            .el-dialog__header{
                display: none;
            }
            .el-dialog__body{
                padding: 26px 45px 0 26px;
                height: 100%;
                box-sizing: border-box;
                .student-answer_title{
                    font-size: 20px;
                    color: #333333;
                }
                .student-answer_container{
                    height: calc(100% - 117px);
                    padding: 23px 0 0 0;
                    box-sizing: border-box;
                    overflow: auto;
                    .student-answer_content{
                        overflow: hidden;
                        display: flex;
                        align-items: flex-start;
                        justify-content: flex-start;
                        flex-wrap: wrap;
                        .student_item{
                            width:123px;
                            height:46px;
                            background:rgba(212,212,212,1);
                            box-shadow:0 2px 4px 0 rgba(212,212,212,.5);
                            border-radius:8px;
                            display: flex;
                            align-items: center;
                            justify-content: flex-start;
                            box-sizing: border-box;
                            padding-left: 16px;
                            margin-right: 12px;
                            /*cursor: pointer;*/
                            color: white;
                            line-height: 1;
                            margin-bottom: 10px;
                            .code{
                                width: 35px;
                                font-size: 15px;
                                white-space: nowrap;
                            }
                            .student_item_right{
                                display: flex;
                                align-items: center;
                                justify-content: flex-start;
                                flex-wrap: wrap;
                                font-size: 15px;
                                div{
                                    white-space: nowrap;
                                }
                            }
                        }
                        .student_item:nth-child(8n) {
                            margin-right: 0;
                        }
                        .student_item:nth-child(16n){
                            margin-bottom: 30px;
                        }
                        .err{
                            background:#f7733d;
                            box-shadow:0 2px 4px 0 rgba(255,195,189,1);
                        }
                        .suc{
                            background:rgba(41,160,254,1);
                            box-shadow:0 2px 4px 0 rgba(157,212,255,1);
                        }
                        .half{
                            background:#feb15b;
                            box-shadow:0px 2px 4px 0px rgba(255,223,187,1);
                        }
                    }
                }
                .student-answer_close{
                    box-shadow:0px 0px 20px 0px rgba(0,0,0,0.06);
                    text-align: center;
                    margin-top: 23px;
                    height: 66px;
                    line-height: 66px;
                    .answer_close_btn{
                        width:205px;
                        height:37px;
                        border-radius:5px;
                        border:2px solid rgba(41,150,243,1);
                        font-size: 16px;
                        color: #2996F3;
                        background: white;
                        line-height: 1;
                    }
                }
            }
        }
        /deep/ .answer-dialog{
            width:803px;
            height: 644px;
            text-align: left;
            background:rgba(255,255,255,1);
            box-shadow:0 0 20px 0 rgba(0,0,0,0.15);
            border-radius:17px;
            position: relative;
            top: calc(50% - 322px);
            margin: 0 auto;
            .el-dialog__header{
                display: none;
            }
            .el-dialog__body{
                padding: 23px 50px;
                height: 100%;
                box-sizing: border-box;
                .answer_title{
                    font-size: 33px;
                    color: #F7933D;
                }
                .answer_content{
                    min-height:480px;
                }
                .answer_close{
                    text-align: center;
                    .close_btn{
                        width:342px;
                        height:62px;
                        border-radius:8px;
                        border:2px solid rgba(41,150,243,1);
                        background: white;
                        font-size: 32px;
                        color: #2996F3;
                        line-height: 1;
                    }
                }
            }
        }
    }
    @media only screen and (max-height: 741px){
        .question_panel{
            /deep/ .student-answer{
                /*top: 0;*/
            }
        }
    }
    /*@media only screen and (min-width: 1565px) and (max-width: 1764px){*/
    /*    .question_panel{*/
    /*        /deep/ .student-answer{*/
    /*            width:1565px;*/
    /*            .el-dialog__body{*/
    /*                .student-answer_container{*/
    /*                    .student-answer_content{*/
    /*                        .student_item:nth-child(8n) {*/
    /*                            margin-right: 12px;*/
    /*                        }*/
    /*                        .student_item:nth-child(16n){*/
    /*                            margin-bottom: 10px;*/
    /*                        }*/
    /*                        .student_item:nth-child(7n) {*/
    /*                            margin-right: 0;*/
    /*                        }*/
    /*                        .student_item:nth-child(14n){*/
    /*                            margin-bottom: 30px;*/
    /*                        }*/
    /*                    }*/
    /*                }*/
    /*            }*/
    /*        }*/
    /*    }*/
    /*}*/
    /*@media only screen and (min-width: 1360px) and (max-width: 1565px){*/
    /*    .question_panel{*/
    /*        /deep/ .student-answer{*/
    /*            width:1360px;*/
    /*            .el-dialog__body{*/
    /*                .student-answer_container{*/
    /*                    .student-answer_content{*/
    /*                        .student_item:nth-child(7n) {*/
    /*                            margin-right: 12px;*/
    /*                        }*/
    /*                        .student_item:nth-child(14n){*/
    /*                            margin-bottom: 10px;*/
    /*                        }*/
    /*                        .student_item:nth-child(8n) {*/
    /*                            margin-right: 12px;*/
    /*                        }*/
    /*                        .student_item:nth-child(16n){*/
    /*                            margin-bottom: 10px;*/
    /*                        }*/
    /*                        .student_item:nth-child(6n) {*/
    /*                            margin-right: 0;*/
    /*                        }*/
    /*                        .student_item:nth-child(12n){*/
    /*                            margin-bottom: 30px;*/
    /*                        }*/
    /*                    }*/
    /*                }*/
    /*            }*/
    /*        }*/
    /*    }*/
    /*}*/
    /*@media only screen and (min-width: 1200px) and (max-width: 1360px){*/
    /*    .question_panel{*/
    /*        /deep/ .student-answer{*/
    /*            width:1150px;*/
    /*            .el-dialog__body{*/
    /*                .student-answer_container{*/
    /*                    .student-answer_content{*/
    /*                        .student_item:nth-child(6n) {*/
    /*                            margin-right: 12px;*/
    /*                        }*/
    /*                        .student_item:nth-child(6n){*/
    /*                            margin-bottom: 10px;*/
    /*                        }*/
    /*                        .student_item:nth-child(7n) {*/
    /*                            margin-right: 12px;*/
    /*                        }*/
    /*                        .student_item:nth-child(14n){*/
    /*                            margin-bottom: 10px;*/
    /*                        }*/
    /*                        .student_item:nth-child(8n) {*/
    /*                            margin-right: 12px;*/
    /*                        }*/
    /*                        .student_item:nth-child(16n){*/
    /*                            margin-bottom: 10px;*/
    /*                        }*/
    /*                        .student_item:nth-child(5n) {*/
    /*                            margin-right: 0;*/
    /*                        }*/
    /*                        .student_item:nth-child(10n){*/
    /*                            margin-bottom: 30px;*/
    /*                        }*/
    /*                    }*/
    /*                }*/
    /*            }*/
    /*        }*/
    /*    }*/
    /*}*/
    /*@media only screen and (max-width: 1200px){*/
    /*    .question_panel{*/
    /*        /deep/ .student-answer{*/
    /*            width:950px;*/
    /*            .el-dialog__body{*/
    /*                .student-answer_container{*/
    /*                    .student-answer_content{*/
    /*                        .student_item:nth-child(5n) {*/
    /*                            margin-right: 12px;*/
    /*                        }*/
    /*                        .student_item:nth-child(10n){*/
    /*                            margin-bottom: 10px;*/
    /*                        }*/
    /*                        .student_item:nth-child(6n) {*/
    /*                            margin-right: 12px;*/
    /*                        }*/
    /*                        .student_item:nth-child(12n){*/
    /*                            margin-bottom: 10px;*/
    /*                        }*/
    /*                        .student_item:nth-child(7n) {*/
    /*                            margin-right: 12px;*/
    /*                        }*/
    /*                        .student_item:nth-child(14n){*/
    /*                            margin-bottom: 10px;*/
    /*                        }*/
    /*                        .student_item:nth-child(8n) {*/
    /*                            margin-right: 12px;*/
    /*                        }*/
    /*                        .student_item:nth-child(16n){*/
    /*                            margin-bottom: 10px;*/
    /*                        }*/
    /*                        .student_item:nth-child(4n) {*/
    /*                            margin-right: 0;*/
    /*                        }*/
    /*                        .student_item:nth-child(8n){*/
    /*                            margin-bottom: 30px;*/
    /*                        }*/
    /*                    }*/
    /*                }*/
    /*            }*/
    /*        }*/
    /*    }*/
    /*}*/
    // 滚动条
    .student-answer_container::-webkit-scrollbar{
        height: 5px;
        width: 5px;
        background-color: transparent;
        border-top: 10px solid transparent;
        border-bottom: 10px solid transparent;
    }
    .student-answer_container::-webkit-scrollbar-thumb {
        border-radius: 6px;
        background-color: rgba(153,153,153,0.3);
    }
    .student-answer_container::-webkit-scrollbar-track {
        /*滚动条里面轨道*/
        box-shadow   : inset 0 0 5px rgba(0, 0, 0, 0.1);
        border-radius: 10px;
        background   : #ededed;
    }
    .student-answer_container::-webkit-scrollbar-thumb:hover{
        background-color: rgba(153,153,153,0.5);
        cursor: pointer;
    }
    .student-answer_container::-webkit-scrollbar-thumb:active{
        background-color: rgba(153,153,153,0.7);
    }
</style>
<style lang="scss">
    .student-answer{
        width:1164px;
        height: 536px;
        text-align: left;
        background:rgba(255,255,255,1);
        box-shadow:0 0 20px 0 rgba(0,0,0,0.15);
        border-radius:17px;
        position: relative;
        top: calc(50% - 268px);
        margin: 0 auto;
        .el-dialog__header{
            display: none;
        }
        .el-dialog__body{
            padding: 26px 0 0 0;
            height: 100%;
            box-sizing: border-box;
            .student-answer_title{
                font-size: 20px;
                color: #333333;
                padding: 0 45px;
            }
            .student-answer_container{
                height: calc(100% - 92px);
                padding: 23px 45px 23px 45px;
                box-sizing: border-box;
                overflow: auto;
                .student-answer_content{
                    overflow: hidden;
                    display: flex;
                    align-items: flex-start;
                    justify-content: flex-start;
                    flex-wrap: wrap;
                    .student_item{
                        width:123px;
                        height:46px;
                        background:rgba(212,212,212,1);
                        box-shadow:0 2px 4px 0 rgba(212,212,212,.5);
                        border-radius:8px;
                        display: flex;
                        align-items: center;
                        justify-content: flex-start;
                        box-sizing: border-box;
                        padding-left: 16px;
                        margin-right: 12px;
                        /*cursor: pointer;*/
                        color: white;
                        line-height: 1;
                        margin-bottom: 10px;
                        .code{
                            width: 35px;
                            font-size: 15px;
                            white-space: nowrap;
                        }
                        .student_item_right{
                            display: flex;
                            align-items: center;
                            justify-content: flex-start;
                            flex-wrap: wrap;
                            font-size: 15px;
                            div{
                                white-space: nowrap;
                            }
                        }
                    }
                    .student_item:nth-child(8n) {
                        margin-right: 0;
                    }
                    .student_item:nth-child(16n){
                        margin-bottom: 30px;
                    }
                    .err{
                        background:#f7733d;
                        box-shadow:0 2px 4px 0 rgba(255,195,189,1);
                    }
                    .suc{
                        background:rgba(41,160,254,1);
                        box-shadow:0 2px 4px 0 rgba(157,212,255,1);
                    }
                    .half{
                        background:#feb15b;
                        box-shadow:0px 2px 4px 0px rgba(255,223,187,1);
                    }
                }
            }
            .student-answer_close{
                box-shadow:0px 0px 20px 0px rgba(0,0,0,0.06);
                text-align: center;
                /*margin-top: 23px;*/
                height: 66px;
                line-height: 66px;
                .answer_close_btn{
                    width:205px;
                    height:37px;
                    border-radius:5px;
                    border:2px solid rgba(41,150,243,1);
                    font-size: 16px;
                    color: #2996F3;
                    background: white;
                    line-height: 1;
                }
            }
        }
    }
    .answer-dialog{
        width:803px;
        height: 644px;
        text-align: left;
        background:rgba(255,255,255,1);
        box-shadow:0 0 20px 0 rgba(0,0,0,0.15);
        border-radius:17px;
        position: relative;
        top: calc(50% - 322px);
        margin: 0 auto;
        .el-dialog__header{
            display: none;
        }
        .el-dialog__body{
            padding: 23px 50px;
            height: 100%;
            box-sizing: border-box;
            .answer_title{
                font-size: 33px;
                color: #F7933D;
            }
            .answer_content{
                min-height:480px;
            }
            .answer_close{
                text-align: center;
                .close_btn{
                    width:342px;
                    height:62px;
                    border-radius:8px;
                    border:2px solid rgba(41,150,243,1);
                    background: white;
                    font-size: 32px;
                    color: #2996F3;
                    line-height: 1;
                }
            }
        }
    }
    @media only screen and (max-width: 1200px){
        .student-answer{
            width:900px;
            .el-dialog__body{
                .student-answer_container{
                    .student-answer_content{
                        .student_item:nth-child(8n) {
                            margin-right: 12px;
                        }
                        .student_item:nth-child(16n){
                            margin-bottom: 10px;
                        }
                        .student_item:nth-child(6n) {
                            margin-right: 0;
                        }
                        .student_item:nth-child(12n){
                            margin-bottom: 30px;
                        }
                    }
                }
            }
        }
    }
</style>
